export class StorageElementDepth {
    name: string;
    type: string | null;
    maxdepth?: number;
    mindepth?: number;
    constructor(name: string, type: string | null, maxdepth?: number, mindepth?: number) {
        this.name = name;
        this.type = type;
        this.maxdepth = maxdepth;
        this.mindepth = mindepth;
    }
}